import React, { useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const initialValues = {
};

const validationSchema = Yup.object({

});

const Create = () => {

    const { addData } = useEntityCrud('Business/setDeliverAgent');
    const navigate = useNavigate();

    const [groupList, setGroupList] = useState([]);
    const [deliveryType, setDeliveryType] = useState(0);
    const [businessList, setBusinessList] = useState([]);
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: ""
    })


    let userDataBusinessId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).businessId : {};


    const onSubmit = (values) => {
        debugger
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "vehicleNo": values.delivervehicle1 + values.delivervehicle2,
            "isActive": true,
            "businessId": userDataBusinessId[0] || orgAddress.buisnessId.value,
            "description": values.description,
            "person": {
                "offset": 0,
                "limit": 10,
                "name": values.name,
                "lastName": values.lastName,
                "nationalCode": values.nationalCode,
                "phone": values.phone,
                "cellphone": values.cellphone,
                "email": "",
                "isActive": true,
                "roleId": 0,
                "branchId": 0,
                "personTypeId": 0,
                "branchTitle": ""
            }
        };
         addData(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('پیک جدید با موفقیت ایجاد شد');
                return navigate('/Deliveries');
            } else
                toast.error(data.message);
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });


    const handleBack = () => {
        navigate('/Deliveries', { replace: true });
    }




    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد پیک جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    deliveryType={deliveryType} setDeliveryType={setDeliveryType}
                    groupList={groupList} setGroupList={setGroupList}
                    businessList={businessList} setBusinessList={setBusinessList}
                    orgAddress={orgAddress} setOrgAddress={setOrgAddress} />
            </div>
        </div>
    );
}

export default Create;